export default {
  en: {
    auth_with_email_or_username: "Email or Username",
    login: "Login",
    forgot_password: "Forgot Password?",
    enter: "Enter",
    password_hint: "At least 10 characters",
    password: "Password",
    username: "Username",
    email: "Email",
    reset: "Reset",
    network_error: "Network Error, please try again!",
    login_error: "Error in logging in, please try again!",
    error_dialog: {
      title: "Error",
      close: "Close",
    },
    username_rules: {
      username_required: "Username is required",
      username_min: "Username must be less than 10 characters",
      username_max: "Username must be 3 or more characters",
    },
    password_rules: {
      password_required: "Password is required",
      password_complexity: "Password must have characters and numbers",
      password_min: "Password must be 10 or more characters",
    },
    tenant: "Tenant",
    tenant_placeholder: "Your tenant / workspace",
    tenant_rules: {
      tenant_required: "Tenant is required",
    },
  },
  ar: {
    auth_with_email_or_username: "البريد الإلكتروني أو اسم المستخدم",
    login: "تسجيل الدخول",
    forgot_password: "نسيت كلمة المرور؟",
    enter: "دخول",
    password_hint: "الحد الأدني لعدد الأحرف هو 10",
    password: "كلمة المرور",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    reset: "تفريغ",
    network_error: "خطأ في الشبكة، يرجى المحاولة مرة أخرى!",
    login_error: "خطأ في تسجيل الدخول، يرجى المحاولة مرة أخرى!",
    error_dialog: {
      title: "خطأ",
      close: "إغلاق",
    },
    username_rules: {
      username_required: "اسم المستخدم مطلوب",
      username_min: "يجب أن يكون اسم المستخدم أقل من 10 أحرف",
      username_max: "يجب أن يتكون اسم المستخدم من 3 أحرف أو أكثر",
    },
    password_rules: {
      password_required: "كلمة المرور مطلوبة",
      password_complexity: "كلمة المرور يجب أن تحتوي على أحرف وأرقام",
      password_min: "يجب أن تتكون كلمة المرور من 10 أحرف أو أكثر",
    },
    tenant: "النطاق",
    tenant_placeholder: "النطاق الخاص بك",
    tenant_rules: {
      tenant_required: "النطاق مطلوب",
    },
  },
};
